import configStore from "../../stores/ConfigStore";
import { ResourceAccessRule } from "../../domain/auth/ResourceAccessRule";
import { PredefinedResourceType } from "../../domain/api/meetings/PredefinedResourceType";


export default class ResourceAccessRuleDataService {

    /**
     * Gets the resource licences of the given resource
     *
     * @static
     * @param {PredefinedResourceType} rtype
     * @param {string} resourceId
     * @returns {Promise<UserBasicInfo>}
     * @memberof ResourceAccessRuleDataService
     */
    public static async getAccessLicencesAsync(rtype: PredefinedResourceType, resourceId: string): Promise<ResourceAccessRule[]> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/resourceAccessRules/${rtype}/${resourceId}`, {
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json())
    }
}
